export const Text = Object.freeze({
	BY_CARD: 'By Cards',
	BY_SELLER: 'By Sellers',
	SAVED_CARDS: 'Saved Cards',
	LOGOUT: 'Logout',
	SELLER: 'Seller',
	SAVED_ON: 'Saved on',
	DELETE: 'Delete',
	CARD: 'Card',
	STATUS: 'Status',
	CONFIRM_DELETE_TITLE: 'Are you sure you want to delete this card?',
	CANCEL: 'Cancel',
	DELETE_CARD: 'Delete Card',
	DELETING_YOUR_CARD: 'Deleting your card',
	DELETING_CARD_DESCRIPTION:
		'This may take a few seconds. Please do not close this window',
	CARD_DELETED_SUCCESS_TITLE: 'Card deleted from seller',
	CARD_DELETED_FAILURE_TITLE: 'Unable to delete card',
	CARD_DELETED_FAILURE_DESCRIPTION:
		'We were unable to delete your card. Please retry',
	OKAY: 'Okay',
	TRY_AGAIN: 'Try Again',
	NO_CARDS_FOUND: `You don’t have any saved cards`,
	LOGIN_USING_PHONE_PE_HEADER: 'Login using mobile number',
	LOGIN_USING_PHONE_PE_DESCRIPTION:
		'Manage cards saved through PhonePe across different platforms.',
	CLICK_TO_LOGIN_WITH_PHONE_PE: 'Click to login with PhonePe',
});
